<template>
  <div class="so" :class="{'active':active,'child-active':childScreenActive}">
    <div class="so__overlay" @click="deactivate">
    </div>
    <div class="so__content">
      <div class="configurator-quote">
        <div class="configurator-quote__header">
          <div class="configurator-quote__heading"><span class="configurator-quote__heading__text">Your Estimate</span>
            <span class="configurator-quote__heading__total">${{ quoteTotalFormatted }}</span>
          </div>
        </div>

        <div class="configurator-quote__content">
          <div class="configurator-quote__items">
            <div v-for="item in quote.items" class="configurator-quote__item">
              <div class="configurator-quote__item__header">
                <div class="configurator-quote__item__title">
                  <div class="configurator-quote__item__title__text">{{ item.productName }}</div>
                  <div>{{ item.productVariantSku }} | Qty: {{ item.qty }}</div>
                </div>
                <div class="configurator-quote__item__price">${{ formatMoney(item.totalPrice) }}</div>
              </div>

              <ul class="configurator-quote__item__desc">
                <li v-for="line in item.descriptionLines">
                  {{ line }}
                </li>
              </ul>
              <div class="configurator-quote__item__actions">
                <div class="btn-remove" @click="() => removeFromQuote(item.id)">
                  Remove
                </div>
              </div>

            </div>
          </div>
          <div v-if="quote.items && !quote.items.length">
            <p>You haven't added any items to your Estimate. <a href="/configurator">Browse our configurable products</a>
              to get
              started.</p>
          </div>
        </div>
        <div class="configurator-quote__footer">
          <div class="configurator-quote__footer__label">
            List Pricing Shown
          </div>
          <!--div class="configurator-quote__footer__disclaimer">
            <span>!</span> <b>Please note:</b> We're currently updating the pricing in our configurator - please bear with us while it's going through updates! Contact our team for a precise quote.
          </div-->
          <div class="configurator-quote__footer__main">
            <div @click="() => this.active = false" class="configurator-quote__close">Close</div>
            <a :href="quote.pdfUrl" class="button"
               :class="{'disabled':(quote.items && !quote.items.length) || !quote.pdfUrl}">Export PDF</a>
          </div>
        </div>
      </div>
      <loading :active.sync="loading"
               :can-cancel="false"
               color="#2C9199"
               :z-index="5"
               :is-full-page="false"></loading>
    </div>
  </div>
</template>

<script>

import axios from 'axios';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'ConfiguratorSlideOut',
  data: function () {
    return {
      loading: false,
      active: false,
      childScreenActive: false,
      quote: [],
      triggerAddToQuote: false,
      triggerGetQuote: false,
      listId: false
    }
  },
  props: {
    csrfTokenName: {
      Type: String
    },
    csrfTokenValue: {
      type: String
    },
    invalid: {},
    invalidVariantAttributes: {},
    selectedVariantAddonBlocks: {},
    handle: {},
    elementId: {},
    attributes: {},
    selectedVariantId: {},
    selectedOptions: {},
    qty: {}
  },
  watch: {
    'triggerAddToQuote'(val) {
      if (val) {
        this.addToQuote();
        this.triggerAddToQuote = false;
      }
    },
    'triggerGetQuote'(val) {
      if (val) {
        this.getQuote();
        this.triggerGetQuote = false;
      }
    },
  },
  created() {
    this.$root.$on('deactivate', this.deactivate);

    document.addEventListener('click', (event) => {

      const openAttr = event.target.getAttribute('data-slide-out-open');
      const openAddAttr = event.target.getAttribute('data-slide-out-open-add');
      const closeAttr = event.target.getAttribute('data-slide-out-close');

      this.triggerAddToQuote = false;

      if (openAddAttr && openAddAttr === this.handle) {
        this.triggerAddToQuote = true;
        this.active = true;
      }

      if (openAttr && openAttr === this.handle) {
        this.triggerGetQuote = true;
        this.active = true;
      }

      if (closeAttr && closeAttr === this.handle) {
        this.active = false;
      }
    }, this);

  },
  computed: {
    quoteTotalFormatted() {
      let amount = this.quote.total ?? 0;
      let decimalCount = 2;
      let decimal = ".";
      let thousands = ",";

      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign +
            (j ? i.substr(0, j) + thousands : '') +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
            (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
      } catch (e) {
        console.log(e)
      }
    }
  },
  methods: {
    deactivate() {
      this.active = false;
    },
    getQuote() {

      this.loading = true;

      axios.get('/actions/quotes-module/default/get-quote').then(function (response) {

        const data = response.data;
        this.loading = false;

        if (data.success) {
          this.quote = data.quote;
        } else {

        }

      }.bind(this)).catch(function (error) {

      }.bind(this))
    },
    addToQuote() {

      if (!this.invalid) {


        let data = new FormData();

        data.append(this.csrfTokenName, this.csrfTokenValue);
        data.append('elementId', this.elementId);
        data.append('fields[productVariant][]', this.selectedVariantId);
        data.append('fields[productVariantQty]', this.qty > 0 ? this.qty : 1);

        if (this.quote.listId) {
          data.append('listId', parseInt(this.quote.listId));
        }
        if (Object.keys(this.selectedOptions).length) {
          data.append('fields[productOptionData]', JSON.stringify(this.selectedOptions));
        }

        if (this.selectedVariantAddonBlocks.length) {
          let productAddonData = {
            'variantAddonBlocks': this.selectedVariantAddonBlocks
          };
          data.append('fields[productAddonData]', JSON.stringify(productAddonData));
        }

        data.append('action', 'wishlist/items/add');
        this.loading = true;

        axios.post('', data).then(function (response) {

          const data = response.data;

          if (data.success) {
            this.getQuote();
          } else {
            this.loading = false;
          }

        }.bind(this))
      }
    },
    removeFromQuote(id) {
      let data = new FormData();
      data.append(this.csrfTokenName, this.csrfTokenValue);
      data.append('itemId', id);
      data.append('action', 'wishlist/items/remove');

      axios.post('', data).then(function (response) {

        const data = response.data;

        if (data.success) {
          this.getQuote();
        } else {
          this.loading = false;
          if (data.error) {

          }
        }

      }.bind(this))
    },
    formatMoney(amount) {

      let decimalCount = 2;
      let decimal = ".";
      let thousands = ",";

      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + (j ? i.substr(0, j) + thousands : '') +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
            (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");

      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style lang="scss" type="text/scss">

.configurator-quote {

  display: flex;
  flex-direction: column;
  height: 100%;

  .btn-remove {
    border: none;
    margin-top: 6px;
    border-bottom: 1px solid red;
    cursor: pointer;
    font-size: 11px;
    padding: 3px 0 6px 0;
    
    display: inline-block;
    font-weight: 600;
    letter-spacing: .05em;
    transition: 150ms color ease-in-out;


    &:hover {
      color: #000000;

    }
  }

  &__heading {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    font-weight: bold;
    font-size: 24px;

    &__text {
      flex: 1;
      color: #2B2A28;
    }

    &__total {
      color: #2C9199;
    }
  }

  &__items {

  }

  &__item {

    margin-bottom: 12px;
    border-bottom: 2px solid #ddd;
    padding: 16px 0;

    &:last-of-type {
      border-bottom: none;
    }

    ul {
      margin-bottom: 0;
    }

    &__header {
      padding-bottom: 10px;
      display: flex;
      flex-direction: row;
      font-size: 15px;
    }

    &__price {
      color: #2C9199;
      font-weight: bold;
      font-size: 17px;

    }

    &__title {
      flex: 1;
      padding-right: 12px;

      &__text {
        color: #2B2A28;
        font-weight: bold;
        font-size: 17px;
        padding-bottom: 4px;

      }
    }


    &__actions {
      padding: 10px 0;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }

    &__desc {
      text-transform: capitalize;
      font-size: 14px;
    }

  }

  &__content {
    padding: 24px;
    flex: 1;
    overflow: auto;
  }


  &__header {
    padding: 24px;
    border-bottom: 1px solid #c5c5c5;
  }

  &__close {
    font-size: 13px;
    cursor: pointer;
    letter-spacing: 0.05em;
    padding: 0 6px;
    margin-right: 16px;

    &:hover {
      color: #000000;
    }
  }

  &__footer {
    background-color: #ecebeb;

    &__label {
      padding: 10px 10px;
      text-align: center;
      border-bottom: 1px solid #c5c5c5;
      background-color: #F4F4F5;
      font-size: 14px;
    }

    &__disclaimer {
      font-size: 12px;
      color: #fff;
      background-color: #2B2A28;
      text-align: center;
      line-height: 18px;
      padding: 10px 20px;


      & span {
        position: relative;
        display: inline-block;
        padding-right: 10px;
        z-index: 1;
        line-height: normal;
      }
      
      & span::after {
        content: '';
        width: 0;
        height: 0;
        border-right: 11px solid transparent;
        border-bottom: 18px solid #2C9199;
        border-left: 11px solid transparent;
        display: block;
        position: absolute;
        top: -3px;
        left: -9px;
        z-index: -1;
      }
    }

    &__main {
      padding: 24px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }

    .button {
      text-align: center;

      &:first-of-type {
        margin-right: 6px;
      }
    }
  }
}

.so {
  opacity: 0;
  pointer-events: none;
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 100;


  &.active {
    display: block;
    opacity: 1;
    pointer-events: all;

    .so__overlay {
      opacity: 1;
    }

    .so__content {
      transform: translateX(0px);
    }
  }


  &__overlay {
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    opacity: 0;
    transition: opacity 200ms ease-in-out;
  }

  &__content {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
    background-color: #fff;
    position: absolute;
    height: 100%;
    width: 380px;
    right: 0;
    top: 0;
    transform: translateX(100%);
    transition: transform 200ms cubic-bezier(0, .52, 0, 1);
  }

  button:disabled {
    transition: all 200ms ease-in-out;
    pointer-events: none;
    opacity: 0.5;
    user-select: none;
  }

  .button.disabled {
    transition: all 200ms ease-in-out;
    pointer-events: none;
    opacity: 0.5;
    user-select: none;
  }
}
</style>
